<script>
    wyvr: {
        render: 'hydrate';
    }

    import { set_focus } from '/srv/web/wyvr/html/releases/58819/gen/client/form/Base.js?1733898724924';

    /**
     * <Email id={'id'} bind:value={value} required={false} disabled={false} focus={false} readonly={false}>Label</Email>
     */

    export let id = null;
    export let name = null;
    export let value = null;
    export let required = false;
    export let disabled = false;
    export let focus = false;
    export let placeholder = null;
    export let readonly = false;

    let input;

    $: get_name = name ? name : id;
    $: set_focus(focus, input);
</script>

<div class="base">
    <input type="email" name={get_name} {id} {required} {disabled} bind:value bind:this={input} {placeholder} {readonly} />

    {#if $$slots.default}
        <label for={id}><slot /></label>
    {/if}
</div>


<style>
    .base {     display: flex;     flex-direction: column-reverse;     margin-bottom: var(--size);     position: relative;     margin-top: 0.5rem; }  .base [required] + label:after {     content: '*';     color: var(--color-error); }  label {     padding-bottom: calc(var(--size) * 0.25);     display: block;     text-transform: uppercase;     font-size: 1rem;     color: var(--h4__color);     font-weight: 600;     line-height: var(--line-height__base);     margin-bottom: 0; }  label * {     display: inline-block; }  [disabled] {     filter: grayscale(1);     opacity: 0.5;     pointer-events: none; } 
    input:not([type='submit']) {     min-height: var(--form-height);     background: var(--form-background);     color: var(--form-color);     font-size: var(--form-font-size);     font-weight: var(--form-font-weight);     line-height: 1;     padding: var(--form-padding);     border: var(--form-border);     width: auto;     border-radius: var(--form-border-radius);     outline: none;     -webkit-box-shadow: none;     box-shadow: none;     -webkit-transition: -webkit-box-shadow 0.5s ease-in-out;     transition: -webkit-box-shadow 0.5s ease-in-out;     transition: box-shadow 0.5s ease-in-out;     transition: box-shadow 0.5s ease-in-out, -webkit-box-shadow 0.5s ease-in-out; }  input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {     -webkit-appearance: none;     margin: 0; }  input:focus {     -webkit-box-shadow: 2px 0 5px -1px rgba(0,0,0,.15);     box-shadow: 2px 0 5px -1px rgba(0,0,0,.15);     -webkit-transition: -webkit-box-shadow .5s ease-in-out;     transition: -webkit-box-shadow .5s ease-in-out;     transition: box-shadow .5s ease-in-out;     transition: box-shadow .5s ease-in-out, -webkit-box-shadow .5s ease-in-out; }  
</style>